import { useQuery, useSubscription } from "@apollo/client";
import { OC_GET_PERMIT, OC_PERMIT_SUBSCRIPTION } from "oc/graphql";
import { useOcPolling } from "oc/hooks";

export const useOcPermit = () => {
  const { data, loading, error, refetch } = useQuery(OC_GET_PERMIT, {
    fetchPolicy: "network-only",
    pollInterval: useOcPolling(1000 * 10),
  });

  const { data: subsData } = useSubscription(OC_PERMIT_SUBSCRIPTION, {
    fetchPolicy: "network-only",
  });

  let result = subsData?.permit ? subsData?.permit : data?.permit;

  return {
    data: result,
    loading,
    error,
    refetch,
  };
};

export default useOcPermit;
